<template>
  <v-layout row wrap fluid>
    <v-flex xs6 md1 pa-1>
      <v-text-field v-model="storicoIscrizione.Anno" readonly label="Anno" hide-details class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs6 md3 pa-1>
      <v-text-field v-model="storicoIscrizione.Denominazione" readonly label="Arciere" hide-details class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs6 md3 pa-1>
      <v-text-field v-model="storicoIscrizione.CodiceFiscale" readonly label="Codice fiscale" hide-details name="Arciere" class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs6 md4 pa-1>
      <v-text-field v-model="storicoIscrizione.Email" readonly label="Email" hide-details name="Arciere" class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs12 md4 pa-1>
      <v-text-field v-model="storicoIscrizione.AssociazioneDenominazione" readonly label="Sodalizio" hide-details name="Arciere" class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs4 md2 pa-1>
      <v-text-field v-model="storicoIscrizione.NumeroTessera" readonly label="Numero Pass" hide-details name="numeroTessera" class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs4 md2 pa-1>
      <v-text-field v-model="storicoIscrizione.TesseraCsain" readonly label="Tessera Csain" hide-details name="TesseraCsain" class="readonly-field"></v-text-field>
    </v-flex>

    <v-flex xs6 md2 pa-1>
      <v-text-field v-model="storicoIscrizione.StatoAnagrafica" readonly label="Stato" hide-details name="Arciere" class="readonly-field"></v-text-field>
    </v-flex>
    <v-flex xs6 md2 pa-1>
      <v-text-field v-model="storicoIscrizione.StatoIscrizione" readonly label="Stato iscrizione" hide-details name="Arciere" class="readonly-field"></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { bus } from '@/main';
  import Security from '@/security';
  import Util from '@/util';

  export default {
    provide() {
      return { parentValidator: this.$validator };
    },
    props: ['storicoIscrizione'],
    data() {
      return {
        Util,
        ruoli: Security.ruolo,
        formModes: Util.enFormMode,
        elencoFunzioni: Security.enFunzione,
        propFormMode: Util.enFormMode.MODIFICA,
        mode: this.propFormMode,
        valid: false,
        switch1: true,
        tessera: ['MULTIDISCIPLINARE BASIC', 'MULTIDISCIPLINARE PLUS', 'PLUS+SANITARIA'],
      };
    },
    computed: {
      ...mapGetters('associatiModule', ['getStoricoIscrizione', 'getStoricoIscrizioni']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),
      ...mapGetters('associazioniModule', ['getAssociazione']),
      associazione() {
        return this.getAssociazione;
      },
      modifyMode() {
        return this.propFormMode === this.formModes.MODIFICA;
      },
      insertMode() {
        return this.propFormMode === this.formModes.INSERIMENTO;
      },
      viewMode() {
        return this.propFormMode === this.formModes.VISUALIZZAZIONE;
      },
      isAdmin() {
        if (this.userData.Role) {
          return (this.propFormMode === this.formModes.MODIFICA && this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO) || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
      isEditModeAdmin() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
          }
        }
        return retVal;
      },
      isEditMode() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
            if (this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.checkFunzione(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE)) {
              retVal = true;
            }
          }
        }
        return retVal;
      },
    },
    watch: {
      propFormMode() {
        this.mode = this.propFormMode;
      },
      $props: {
        handler() {
          // date formattate da visualizzare nei campi del form
          this.DataRichiestaFormattata = this.storicoIscrizione.DataRichiesta ? this.formatDate(this.storicoIscrizione.DataRichiesta) : null;
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      const vm = this;
    },
    methods: {
      ...mapActions('associazioniModule', ['loadAssociazione']),
      ...mapActions('associatiModule', ['loadStoricoIscrizione', 'loadStoricoIscrizioni', 'updateStoricoIscrizione']),
      closeDialog() {
        this.$emit('reset-elm');
        bus.$emit('associatoDialog', false);
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      isUtente(item) {
        let retVal = false;
        if (item.Utente != null && item.Utente.id != null) {
          retVal = true;
        }
        return retVal;
      },

      canModifyAssociato(idAssociato, idAssociazione) {
        let retVal = false;
        if (idAssociato) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      formatDate(date) {
        return Util.formattaData(date);
      },
      canInsertAssociato(idAssociazione) {
        let retVal = false;
        if (this.mode == this.formModes.INSERIMENTO) {
          if (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId) {
            retVal = Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },

      canViewAssociato(idAssociato) {
        let retVal = false;
        if (idAssociato) {
          if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO, this.userData.Role) && this.mode == this.formModes.VISUALIZZAZIONE) {
            retVal = true;
          }
        }
        return retVal;
      },

      canManageUser() {
        return this.userData.Role == Security.ruolo.UTENTE_AMMINISTRATIVO || this.userData.Role == Security.ruolo.RESPONSABILE_ASSOCIAZIONE;
      },

      checkFormMode(insertMode) {
        if (
          insertMode &&
          (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role) ||
            Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE, this.userData.Role))
        ) {
          this.mode = this.formModes.INSERIMENTO;
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO, this.userData.Role)) {
          this.mode = this.formModes.VISUALIZZAZIONE;
          return this.formModes.VISUALIZZAZIONE;
        }
      },
    },
  };
</script>
